import React from 'react';
import { Member } from '../../filters-form/types';

interface UseMemberBadges {
  memberIds?: string[];
  members?: Member[];
}

export const useMemberBadges = ({ memberIds = [], members = [] }: UseMemberBadges) => {
  const memberBadges = React.useMemo(() => members?.filter((member) => memberIds.includes(String(member.id))), [
    members,
    memberIds,
  ]);

  return {
    memberBadgesProps: {
      data: memberBadges,
    },
  };
};
